<template>
   <footer class="header_sticky" style="border-top: 6px solid #00f173; height: auto; margin: 0 auto; padding: 10px 0; width: 100%; z-index: 1; bottom: 0;">
		<div class="container">
			<div class="row">
				<div class="col-md-1" style="padding: 5px 20px;">
					<div id="logo_home_footer" class="logo_home_foot">
						<h1>
							<a href="/" title=""></a>
						</h1>
					</div>
				</div>
				<nav class="col-md-6" style="text-align: center; display: inline-grid;">
					<div class="main-menu-footer" style="text-align: center;">
						<ul>
							<li class="submenu">
								<a style="text-decoration: none;" @click="menuClick($event, '/about')" href="/about">{{ $t('about_us') }}</a>
							</li>
							<li class="submenu">
								<a style="text-decoration: none;" @click="menuClick($event, '/faq')" href="/faq">FAQ</a>
							</li>
							<li class="submenu">
								<a style="text-decoration: none;" @click="menuClick($event, '/privacy-policy')" href="/privacy-policy">Privacy Policy</a>
							</li>
                     <li class="submenu">
								<a style="text-decoration: none;" @click="menuClick($event, '/register')" href="/register">{{ $t('register_menu') }}</a>
							</li>
						</ul>
					</div>
				</nav>
				<div class="col-md-5">
					<div id="logo_home_footer" style="font-size: 14px; color: #ffffff; margin-top: 10px; font-family: Gotham-Bold;">
						tkon.id by PT Sarana Berkat Sukses Mandiri Sejati &copy;2020
					</div>
				</div>
			</div>
		</div>
	</footer>
</template>

<script>
export default {
	name: 'footbar',
	methods: {
		menuClick(event, destination){
			event.preventDefault()
			this.$router.push(`/${this.$i18n.locale}${destination}`)
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/core/footbar.vue